import { CommissionListColumn } from '../../dave-commission-module/components/commission-list/commission-list.component';
import { CKEditorDefaultConfigEmailFontFamilyOptions,CKEditorDefaultConfigEmailFontSizeOptions } from '../../helper/ckeditor.helper';
import { DashboardItemsDataType } from '../../mocks/dashboard-items-data';
import { PartnerType } from '../graphql-types';
import { BackendDate } from '../helper/backend-frontend-conversion.helper';
import { LedgerImportDocumentTypes } from './ledger-import.entity';
import { CustomLabels } from '../../services/custom-label/custom-labels';
import { CommissionWizardSteps } from './commissionType.entity';
import { TwoFactorMethodEnum } from './user.entity';

export enum PartnerSpecificationType {
    Construction = 1,
    /** Sachverständige */
    Appraiser = 2,
}
export enum PartnerTypeEnum {
    Dave = 1,
    Obligo = 2,
    Zert = 3,
    Kagetec = 4,
    TSB = 5,
    YustInfra = 6,
}
export interface PartnerEntitySettings {
    hiddenDefaultClockInTypes?: number[];
    defaultVAT?: number;
    defaultNK?: number;
    customerIdForLedgerImportsFromWarehouseMovementCSVImport?: number;
    defaultPartieStd?: number;
    useOfflineApp?: boolean;
    WizardSteps?: CommissionWizardSteps[];
    hiddenDefaultCommissionTypes?: number[];
}
export interface PartnerEntityAdditionalData {
    createCustomerNumberAutomaticDefault?: boolean;
    defaultLedgerImportDocumentType?: LedgerImportDocumentTypes;
    defaultBvCOAId?: number;
    defaultTaxTypeId?: number;
    defaultCountry?: string;
    /**
     * @deprecated
     */
    commissionListPreferredColumns?: CommissionListColumn[];
    dashboardItemsOrder?: DashboardItemsDataType[];
    emailEditorDefaultFontSize?: CKEditorDefaultConfigEmailFontSizeOptions;
    emailEditorDefaultFontFamily?: CKEditorDefaultConfigEmailFontFamilyOptions;
    ReportsListComponentDisplayedColumns?: string[];
    CommissionListComponentDisplayedColumns?: string[];
    ProcessTemplateListComponentDisplayedColumns?: string[];
    ContactListComponentDisplayedColumns?: string[];
    GeneratedDocumentListComponentDisplayedColumns?: string[];
    ProcessListComponentDisplayedColumns?: string[];
    MaterialListComponentDisplayedColumns?: string[];
    ResourceListComponentDisplayedColumns?: string[];
    CommissionDashbordListComponentDisplayedColumns?: string[];
    AvaListComponentDisplayedColumns?: string[];
    /**
     * Anteil des BaseCost, der durch Löhne entstanden ist, nur für Österreich
     */
    useArlSeparateSalaryBaseCost?: boolean;
    ExportBusinessVolumesDialogComponentDisplayedColumns?: string[];
    invoiceEditorCalculation?: boolean;
    useServicePeriod?: boolean;
    invoiceEditorUseCommissionTitle?: boolean;
   // invoiceEditorUseLVCalculation?: boolean;
    invoiceEditorUseSalaryQuantityTypeSwitch?: boolean;
    PurchaseListComponentDisplayedColumns?: string[];
    invoiceEditorUseCommissionInvoiceData?: boolean;
    hideAutomaticCustomerNumberAndCustomerNumber?: boolean;
    commissionDisplayNameCostCenter?: boolean;
}

export class PartnerEntity {
    constructor(
        public Id: number = null,
        public Deleted: boolean = null,
        public CreatedAt: Date = null,
        public MandateReference: string = null,
        public PartnerNo: string = null,
        public PartnerSpecificationTypeId: PartnerSpecificationType = null,
        public PartnerTypeId: PartnerTypeEnum = null,
        public VacationCalculationDefaultProvince: string = null,
        public AdditionalData: PartnerEntityAdditionalData = null,
        public Settings: PartnerEntitySettings = null,
        public MaintenanceFeePercentage: number = null,
        public InvoiceEditorUseLVCalculation: boolean = null,
        public CustomLabels: CustomLabels = null,
        public MFAMethods: TwoFactorMethodEnum[] = null,
    ) {}
    public Clone(override: Partial<PartnerEntity> = {}): PartnerEntity {
        const attr = { ...this, ...override };
        return Object.assign(new PartnerEntity(), attr);
    }
    public static readonly GqlFields: Array<keyof PartnerType> = [
        'createdAt',
        'deleted',
        'id',
        'mandateReference',
        'partnerNo',
        'partnerSpecificationTypeId',
        'partnerTypeId',
        'vacationCalculationDefaultProvince',
        'additionalData',
        'settings',
        'maintenanceFeePercentage',
        'invoiceEditorUseLVCalculation',
        'config',
        'twoFactorMethods',
    ];
}

export function PartnerEntityFromBackend(res: PartnerType): PartnerEntity {
    return new PartnerEntity(
        res.id,
        res.deleted,
        BackendDate(res.createdAt),
        res.mandateReference,
        res.partnerNo,
        res.partnerSpecificationTypeId,
        res.partnerTypeId,
        res.vacationCalculationDefaultProvince,
        res.additionalData as any,
        res.settings as any,
        res.maintenanceFeePercentage,
        res.invoiceEditorUseLVCalculation,
        res.config ? res.config as any : null,
        res.twoFactorMethods,

        // {
        //     // RessourcePlan: {
        //     //     wordBinding: 'BZP',
        //     //     Nominativ: {
        //     //         singular: {
        //     //             article: 'der',
        //     //             value: 'BZP'
        //     //         },
        //     //         plural: {
        //     //             article: 'die',
        //     //             value: 'BZP'
        //     //         }
        //     //     }
        //     // },
        //     CommissionInternalNumber: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Kostenstelle',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Kostenstellen',
        //             }
        //         }
        //     },
        //     CommissionInternalNumberShort: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Kostenstelle',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Kostenstellen',
        //             }
        //         }
        //     },
        //     Department: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Sparte',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Sparten',
        //             }
        //         }
        //     },
        //     ExecutingDepartment: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Leistungssparte',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Leistungssparten',
        //             }
        //         }
        //     },
        //     Customer: {
        //         wordBinding: 'Bauherren',
        //         Nominativ: {
        //             singular: {
        //                 article: 'der',
        //                 value: 'Bauherr',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Bauherren',
        //             }
        //         },
        //         Dativ: {
        //             singular: {
        //                 article: 'dem',
        //                 value: 'Bauherren',
        //             },
        //             plural: {
        //                 article: 'den',
        //                 value: 'Bauherren',
        //             }
        //         }
        //     },
        //     CommissionFreeTextField1: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Zusatzinfo Bauvorhaben',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Zusatzinfos Bauvorhaben',
        //             }
        //         }
        //     },
        //     Commission: {
        //         wordBinding: 'Projekt',
        //         Nominativ: {
        //             singular: {
        //                 article: 'das',
        //                 value: 'Projekt',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Projekte',
        //             },
        //         },
        //         Genitiv: {
        //             singular: {
        //                 article: 'des',
        //                 value: 'Projekts',
        //             },
        //             plural: {
        //                 article: 'der',
        //                 value: 'Projekte',
        //             },
        //         },
        //         Dativ: {
        //             singular: {
        //                 article: 'dem',
        //                 value: 'Projekt',
        //             },
        //             plural: {
        //                 article: 'den',
        //                 value: 'Projekten',
        //             },
        //         },
        //     },
        //     CustomerNumber: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Kundennummer',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Kundennummern',
        //             }
        //         }
        //     },
        //     CustomerNumberShort: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'die',
        //                 value: 'Kunden Nr.',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Kunden Nr.',
        //             }
        //         }
        //     },
        //     CommissionDescription: {
        //         Nominativ: {
        //             singular: {
        //                 article: 'der',
        //                 value: 'Name Bauvorhaben',
        //             },
        //             plural: {
        //                 article: 'die',
        //                 value: 'Namen Bauvorhaben',
        //             }
        //         }
        //     },
        // }
        );
}
